import { ImageIcon, PlusIcon, VideoIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { getScreenFromPathname, mixpanelUtils } from "@/lib/mixpanel/mixpanel";

export const AddMediaMenu = ({
  onAddPhoto,
  onAddVideo,
}: {
  onAddPhoto: () => void;
  onAddVideo: () => void;
}) => {
  const render = () => (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className="h-8 w-fit px-0 text-slate-500 hover:text-slate-700 hover:no-underline focus-visible:ring-2 focus-visible:ring-primary-600"
          type="button"
          variant="link"
        >
          <PlusIcon className="mr-1 h-3.5 w-3.5" />
          Add Media
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[180px]">
        <DropdownMenuItem
          onClick={() => {
            mixpanelUtils.trackButtonClick(
              "Add Photo",
              getScreenFromPathname(location.pathname),
            );
            onAddPhoto();
          }}
        >
          <ImageIcon className="h-4 w-4" />
          Photo
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            mixpanelUtils.trackButtonClick(
              "Add Video",
              getScreenFromPathname(location.pathname),
            );
            onAddVideo();
          }}
        >
          <VideoIcon className="h-4 w-4" />
          Video
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );

  return render();
};
